'use strict';

import { Entity } from '../Entity';

/**
 * Types
 */
export const USER_ACTIVITY_PRIORITY_TYPE = {
  LOW: 'Low',
  MEDIUM: 'Med',
  HIGH: 'High',
} as const;

export type USER_ACTIVITY_PRIORITY_TYPE =
  (typeof USER_ACTIVITY_PRIORITY_TYPE)[keyof typeof USER_ACTIVITY_PRIORITY_TYPE];

export interface UserActivityCategory {
  name: string;
  total?: number;
}

export class UserActivity extends Entity {
  protected activityId;
  protected activityToId;
  protected activityFromId;
  protected activityCategory;
  protected activityPriority;
  protected activityTitle;
  protected activityStatus;
  protected activityDeadline;
  protected activityAffiliation;
  protected activityDetails;
  protected activityDate;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.activityId = data.activityId;
    this.activityToId = data.activityToId;
    this.activityFromId = data.activityFromId;
    this.activityCategory = data.activityCategory;
    this.activityPriority = data.activityPriority;
    this.activityTitle = data.activityTitle;
    this.activityStatus = data.activityStatus;
    this.activityDeadline = data.activityDeadline;
    this.activityAffiliation = data.activityAffiliation;
    this.activityDetails = data.activityDetails;
    this.activityDate = data.activityDate;
  }

  public getActivityId() {
    return this.activityId;
  }

  public getActivityToId() {
    return this.activityToId;
  }

  public getActivityFromId() {
    return this.activityFromId;
  }

  public getActivityCategory() {
    return this.activityCategory;
  }

  public getActivityPriority() {
    return this.activityPriority;
  }

  public getActivityTitle() {
    return this.activityTitle;
  }

  public getActivityStatus() {
    return this.activityStatus;
  }

  public getActivityDeadline() {
    return this.activityDeadline;
  }

  public getActivityAffiliation() {
    return this.activityAffiliation;
  }

  public getActivityDetails() {
    return this.activityDetails;
  }

  public getActivityDate() {
    return this.activityDate;
  }

  public setActivityId(activityId: number): this {
    this.activityId = activityId;
    return this;
  }

  public setActivityToId(activityToId: number | null): this {
    this.activityToId = activityToId;
    return this;
  }

  public setActivityFromId(activityFromId: number | null): this {
    this.activityFromId = activityFromId;
    return this;
  }

  public setActivityCategory(activityCategory: string): this {
    this.activityCategory = activityCategory;
    return this;
  }

  public setActivityPriority(activityPriority: string): this {
    this.activityPriority = activityPriority;
    return this;
  }

  public setActivityTitle(activityTitle: string): this {
    this.activityTitle = activityTitle;
    return this;
  }

  public setActivityStatus(activityStatus: string): this {
    this.activityStatus = activityStatus;
    return this;
  }

  public setActivityDeadline(activityDeadline: string | null): this {
    // or Date | null if you store real Date objects
    this.activityDeadline = activityDeadline;
    return this;
  }

  public setActivityAffiliation(activityAffiliation: number | null): this {
    this.activityAffiliation = activityAffiliation;
    return this;
  }

  public setActivityDetails(activityDetails: string): this {
    this.activityDetails = activityDetails;
    return this;
  }

  public setActivityDate(activityDate: string | Date): this {
    this.activityDate = activityDate;
    return this;
  }
}
